var View = require('views/base/view');

import ActionPlanItemResponsesService from 'services/action-plan-item-responses-service';

var ActionPlanView = View.extend({
  autoRender: true,
  autoAttach: true,
  template: require('./templates/action-plan'),
  className: 'panel panel-default',
  listen: {
    addedToDOM: 'loaded'
  },
  loaded: function() {
    var self = this;
    this.delegate('click', '#clear-action-plan-responses', function(e) {
      ActionPlanItemResponsesService.clear();
      self.render();
      return false;
    });
  },

  getTemplateData: function(){
    var responses = ActionPlanItemResponsesService.readLocal();
    return {
      noResponses: responses.length === 0,
      responses: JSON.stringify(responses)
    };
  }
});

export default ActionPlanView;